import { composeEntityDrawerSelectors } from '@bp/admins-shared/features/entity';

import type { Preset } from '../../models';
import { getEntityState } from '../feature.selectors';

import type { IState } from './preset.reducer';

export const PRESET_DRAWER_SELECTORS = composeEntityDrawerSelectors<Preset, IState>(getEntityState);
